import { HudIcon } from '@hud/web-components/Icons/HudIcons';
import {
  ButtonsContainer,
  CloseIcon,
  Container,
  DontShowAgainButton,
  Content,
  StyledButton,
  Subtitle,
  Title,
} from './ExtensionBanner.styles';
import useAnalytics from '../../hooks/useAnalytics';

interface ExtensionBannerProps {
  onDontShowAgain?: () => void;
  onClose?: () => void;
}

export function ExtensionBanner({ onDontShowAgain, onClose }: ExtensionBannerProps) {
  const analytics = useAnalytics();
  return (
    <Container>
      <Content>
        <Title>
          Install Hud IDE Extension: Build smarter, production-aware code.{' '}
          <em>Now with Hud MCP!</em>
        </Title>
        <Subtitle>
          <span>Power up your AI with real-time production context</span>
          <span>See function-level metrics in your IDE</span>
          <span>Jump from issue to source function in your code</span>
        </Subtitle>
        <ButtonsContainer>
          <StyledButton
            onClick={() => {
              analytics.capture('cursor_vsc_windsurf_button_in_extension_banner_clicked');
              window.open('https://marketplace.visualstudio.com/items?itemName=Hud.hud');
            }}
          >
            <HudIcon icon="ides.cursor" size="18px" />
            <span>Cursor</span>
            <HudIcon icon="ides.vscode" size="16px" />
            <span className="vsc">VSC</span>
            <HudIcon icon="ides.windsurf" size="20px" />
            <span className="windsurf">Windsurf</span>
            <HudIcon icon="trends.arrowUp" size="14px" />
          </StyledButton>
          <StyledButton
            onClick={() => {
              analytics.capture('jetbrains_button_in_extension_banner_clicked');
              window.open('https://plugins.jetbrains.com/plugin/25174-hud');
            }}
          >
            <HudIcon icon="ides.webstormNew" size="22px" />
            <span>PyCharm</span>
            <HudIcon icon="ides.pycharmNew" size="18" />
            <span>WebStorm</span>
            <HudIcon icon="ides.ideaNew" size="18px" />
            <span>IntelliJ</span>
            <HudIcon icon="trends.arrowUp" size="14px" />
          </StyledButton>
        </ButtonsContainer>
      </Content>

      <CloseIcon icon="other.close" size="24px" onClick={onClose} />
      <DontShowAgainButton variant="text" onClick={onDontShowAgain}>
        Don't show again
      </DontShowAgainButton>
    </Container>
  );
}
